import { Component, computed, input } from '@angular/core';
import { KENDO_SKELETON } from '@progress/kendo-angular-indicators';
import { KENDO_CARD } from '@progress/kendo-angular-layout';

@Component({
  selector: 'unity-card-item-count-summary-shared',
  imports: [KENDO_CARD, KENDO_SKELETON],
  templateUrl: './card-item-count-summary-shared.component.html',
  styleUrl: './card-item-count-summary-shared.component.scss',
})
export class CardItemCountSummarySharedComponent {
  public readonly $displayName = input.required<string>({ alias: 'displayName' });
  public readonly $itemCount = input.required<number | undefined>({ alias: 'itemCount' });
  public readonly $isLoading = input.required<boolean>({ alias: 'isLoading' });
  public readonly $hasWarning = input(false, { alias: 'hasWarning' });

  protected readonly $displayText = computed(() => {
    const itemCount = this.$itemCount();
    const displayName = this.$displayName();

    if (itemCount === undefined) {
      return undefined;
    }

    if (itemCount === 0) {
      return `No ${displayName.toLowerCase()}!`;
    }

    return `${itemCount}`;
  });
}
